const State = {
  aggregateData: []
}

export default State
